import styled from 'styled-components'

export const Main = styled.div`
  background-color: #ffffff;
  padding: 1.5rem;
  overflow: auto;
  flex: 1;
`
